/**
 * Stock & borrow: Team Leader (management_id 1) or Inventory bureau (bureau_id 6) only.
 * Admins are not elevated unless they hold one of those roles.
 */

export function canManageInventory(user) {
  if (!user) return false;
  const isTL = Boolean(user.is_team_leader) || Number(user.management_id) === 1;
  const isInventoryBureau = Number(user.bureau_id) === 6;
  return isTL || isInventoryBureau;
}

/** User may archive an active stock item. */
export function canDeleteStock(user, stock) {
  if (!canManageInventory(user) || !stock) return false;
  return !stock.archived_at;
}
